import React from 'react'
import {styled, makeStyles} from '@material-ui/core/styles'
import {useOrganizationTypesState} from 'lms/hooks'
import SectionTitle from 'lms/components/Detail/SectionTitle'

const useStyles = makeStyles(theme => ({
  list: {
    display: 'grid',
    gridTemplateColumns: '1fr',    
  }
}))

const Value = styled('li')({})

const nameSorter = (a, b) => a.name.localeCompare(b.name)

const OrganizationTypes = ({organizationTypes = []}) => {
  const {data} = useOrganizationTypesState()
  const classes = useStyles()

  if (organizationTypes.length === 0) return null

  const sorted = organizationTypes
    .map(id => data.byId[id])
    .filter(Boolean)
    .sort(nameSorter)

  return (
    <>
      <SectionTitle>Organization Types</SectionTitle>
      <ul className={classes.list}>
        {sorted.map(orgType => (
          <Value key={orgType.id}>{orgType.name}</Value>
        ))}
      </ul>
    </>
  )
}

export default OrganizationTypes
